import React, { useRef } from 'react';

import { ReactComponent as SearchIcon } from '../../assets/icons/search-icon.svg';

interface ExpandSearchBarProperties {
  value: string | number;
  onChange: (value: string) => void;
  // eslint-disable-next-line react/no-unused-prop-types
  placeholder?: string;
  isExpanded?: boolean;
  toggleExpand?: () => void;
  direction?: 'ltr' | 'rtl';
}

/**
 * Expandable search bar component
 * @param props - ExpandSearchBarProperties
 * @param props.value - Input value
 * @param props.onChange - Change handler
 * @param props.placeholder - Placeholder text
 * @param props.isExpanded - Expanded state
 * @param props.toggleExpand - Toggle expansion handler
 * @param props.direction - Layout direction ('ltr' or 'rtl')
 * @returns {JSX.Element}
 */
function ExpandSearchBar(properties: ExpandSearchBarProperties) {
  const { value, onChange, placeholder, isExpanded, toggleExpand, direction = 'ltr' } = properties;
  const inputReference = useRef<HTMLInputElement>(null);

  /**
   * Handle focus on input element
   * @param event - Mouse event
   */
  const handleFocus = (event: React.MouseEvent) => {
    event.stopPropagation();
    inputReference.current?.focus();
  };

  return (
    <div
      role="presentation"
      onClick={(event) => handleFocus(event)}
      className="multi-select-wrapper">
      <div
        className={`multi-select-search ${isExpanded || value ? 'expanded' : ''} ${direction === 'ltr' ? 'ltr' : ''}`}
        onClick={toggleExpand}
        role="button"
        tabIndex={0}
        onKeyDown={() => {}}>
        <input
          ref={inputReference}
          type="text"
          className="dropdown-search"
          placeholder={placeholder}
          name="search-bar"
          aria-label="search"
          value={value.toString()}
          onChange={(event) => onChange(event.target.value)}
        />
        <div className="search-box">
          <span>
            <SearchIcon />
          </span>
        </div>
      </div>
    </div>
  );
}

export default ExpandSearchBar;

ExpandSearchBar.defaultProps = {
  placeholder: '',
  isExpanded: false,
  toggleExpand: undefined,
  direction: 'ltr',
};
